// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"32522abe","488":"5db7ddcc","977":"d31f5fb7"}[chunkId] + ".chunk.js";
};